import { useMutation } from "@tanstack/react-query";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function useUpdatePropertyBasics(propertyId) {
  const axiosPrivate = useAxiosPrivate();
  return useMutation({
    mutationFn: (request) => {
      return axiosPrivate({
        method: "PUT",
        url: `Property/${propertyId}/Preferences`,
        data: request,
      });
    },
  });
}

function useUpdatePropertyBasicsv2() {
  const axiosPrivate = useAxiosPrivate();
  return useMutation({
    mutationFn: ({ request, propertyId }) => {
      return axiosPrivate({
        method: "PUT",
        url: `Property/${propertyId}/Preferences`,
        data: request,
      });
    },
  });
}

export { useUpdatePropertyBasics, useUpdatePropertyBasicsv2 };
